import React from "react";

export default function Loading (){
    return(
        <div className="loading">
            <div className="droplet_spinner">
                <div className="droplet"></div>
                <div className="droplet"></div>
                <div className="droplet"></div>
		    </div>
        </div>
    );
};